import React, { useEffect, useRef, useState } from 'react';
import { whyChooseUsPoints } from '../data/mock';

const WhyChooseUs = () => {
  const [counters, setCounters] = useState({});
  const [hasAnimated, setHasAnimated] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated) {
            setHasAnimated(true);
            animateCounters();
          }
        });
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, [hasAnimated]);

  const animateCounters = () => {
    whyChooseUsPoints.forEach((point) => {
      const target = point.stat;
      const isNumber = !isNaN(parseInt(target.replace(/\D/g, '')));
      
      if (isNumber) {
        const number = parseInt(target.replace(/\D/g, ''));
        const suffix = target.replace(/[0-9]/g, '');
        let current = 0;
        const increment = number / 50;
        const timer = setInterval(() => {
          current += increment;
          if (current >= number) {
            setCounters(prev => ({ ...prev, [point.id]: target }));
            clearInterval(timer);
          } else {
            setCounters(prev => ({ ...prev, [point.id]: Math.floor(current) + suffix }));
          }
        }, 30);
      } else {
        setCounters(prev => ({ ...prev, [point.id]: target }));
      }
    });
  };

  return (
    <section id="about" className="why-choose-section" ref={sectionRef}>
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Why Choose AstroClick</h2>
          <p className="section-description">
            Trust in the cosmos, trust in our expertise
          </p>
        </div>
        <div className="why-choose-grid">
          {whyChooseUsPoints.map((point, index) => (
            <div key={point.id} className={`why-choose-card fade-in-up delay-${index}`}>
              <div className="stat-circle">
                <span className="stat-number">{counters[point.id] || '0'}</span>
                <span className="stat-label">{point.statLabel}</span>
              </div>
              <h3 className="why-choose-title">{point.title}</h3>
              <p className="why-choose-description">{point.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;